import moment from 'moment'
import 'moment/locale/es';
import 'moment/locale/pt';
import 'moment/locale/it';


export default function formatLocaleDate(date) {

    const utcDateTime = new Date(date);
    return utcDateTime.toLocaleString();
    
}